import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme, _props: unknown, classes: Record<"agentNameItem", string>) => {
	return ({
		form: {
			backgroundColor: "transparent",
			width: "100%",
			maxWidth: 400,
			borderRadius: 5,
		},
		arrow: {
			color: theme.palette.common.black
		},
		searchIcon: {
			padding: 5
		},
		viewLabel: {
			color: "darkgrey",
			fontSize: "14px",
			paddingLeft: "5px",
			float: "left",
			textTransform: "none" as const,
		},
		agentName: {
			paddingLeft: 5,
			color: theme.palette.custom.navText,
			position: "relative",
			bottom: "5px",
			whiteSpace: "nowrap",
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			maxWidth: "180px",
			textTransform: "none" as const,
		},
		agentNameItem: {
			paddingLeft: 5,
			color: "black",
		},
		nameContainer: {
			overflow: 'hidden',
			textOverflow: "ellipsis",
			whiteSpace: "nowrap",
			alignItems: "center"
		},
		usersIcon: {
			borderRadius: 50,
			backgroundColor: theme.palette.primary.main,
			color: 'white',
			padding: 8,
		},
		popover: {
			maxHeight: 350,
		},
		menuItem: {
			"&:hover": {
				backgroundColor: theme.palette.primary.light,
				[`& .${classes.agentNameItem}`]: {
					color: theme.palette.common.white,
				},
			},
		},
		selected: {
			backgroundColor: theme.palette.primary.light,
			[`& .${classes.agentNameItem}`]: {
				color: theme.palette.common.white,
			},
			"&:hover": {
				backgroundColor: theme.palette.primary.light,
			},
		},
		textField: {
			position: 'sticky',
			top: '0',
			zIndex: 1,
			backgroundColor: theme.palette.common.white,
		}
	} satisfies Record<string, CSSObject>);
};
